import { render, staticRenderFns } from "./BaseWarn.vue?vue&type=template&id=4b400184&scoped=true&"
import script from "./BaseWarn.vue?vue&type=script&lang=js&"
export * from "./BaseWarn.vue?vue&type=script&lang=js&"
import style0 from "./BaseWarn.vue?vue&type=style&index=0&id=4b400184&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b400184",
  null
  
)

export default component.exports